import { IconProps } from "../../utils/global-types/global-types";

const NoteIcon = ({ className, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 18 18"
      className={className ? className : "w-[18px] h-[18px]"}
      {...rest}
    >
      <path
        fill="currentColor"
        d="M12 11.5h3.535a3.4 3.4 0 0 1-.56.73l-2.745 2.745a3.4 3.4 0 0 1-.73.56V12a.5.5 0 0 1 .5-.5"
      ></path>
      <path
        fill="currentColor"
        d="M16 3.5v6.255q.001.376-.08.745H12a1.504 1.504 0 0 0-1.5 1.5v3.92a3.4 3.4 0 0 1-.745.08H3.5A1.504 1.504 0 0 1 2 14.5v-11A1.505 1.505 0 0 1 3.5 2h11A1.504 1.504 0 0 1 16 3.5"
      ></path>
    </svg>
  );
};

export default NoteIcon;
